export namespace ICorp {
  export interface IEntity {
    email: string;
    enabled: boolean;
    id: number;
    name: string;
    refCode: string;
    comment: string;
    parks: number[] | ICorpPark[];
    inArchive?: boolean;
    corpLimitResident?: number;
    cntCars?: number;
    cntCarsGuest?: number;
    ownerCorpName?: string;

    // FE props.
    printedParks?: string;
  }

  export const DefaultFormEntity = {
    email: '',
    enabled: true,
    id: null,
    name: '',
    refCode: '',
    comment: '',
    parks: [],
    inArchive: false,
    corpLimitResident: null,
  }

  export interface ICorpPark {
    id: number;
    name: string;
  }

  export enum UrlGetParams {
    RefLink = 'ref',
  }

  export enum StorageKeys {
    NeedRegByRef = 'needRegistrationByRef',
    URLRegByRef = 'urlRegistrationByRef',
  }

  export enum CorpPopupTab {
    Form = 'form',
    Accounts = 'accounts',
    Log = 'log',
  }
}
